import {
  getPuzzleMiliarderList,
  getPuzzleMiliarderGroupList,
  updateStatusPuzzleMiliarderList,
} from '~/api/general-trade';

const groupListStructure = {
  commission_total: 0,
  puzzle_codes: [],
  count: 0,
};
function getPrevDayOfWeek(date, dayOfWeek) {
  const resultDate = new Date(date.getTime());
  resultDate.setDate(date.getDate() - ((7 - dayOfWeek + date.getDay()) % 7));
  return resultDate;
}
function getNextDayOfWeek(date, dayOfWeek) {
  const resultDate = new Date(date.getTime());
  resultDate.setDate(date.getDate() + ((7 + dayOfWeek - date.getDay()) % 7));
  return resultDate;
}
function getNextIndex(curDay) {
  return [2, 3, 4].includes(curDay) ? 5 : 2;
}
function getPrevIndex(curDay) {
  return [3, 4, 5].includes(curDay) ? 2 : 5;
}
export function modifyGroupList(data) {
  const result = [];
  let index = 0;
  let curDate = new Date(Date.now());
  let curDay = curDate.getDay();
  // add next commission time for first data
  const date = getNextDayOfWeek(curDate, getNextIndex(curDay));
  date.setHours(23, 59, 59, 999);
  if (data.length === 0) return [{ ...groupListStructure, commissioned_at: date.toISOString() }];
  const firstData = data[index];
  if (firstData.commissioned_at !== null) {
    // firstData.commissioned_at = date.toISOString();
    result.push(firstData);
  }
  // loop find prev day [2,5] in previous week
  while (index + 1 < data.length) {
    const prevData = data[index + 1];
    const checkDay = getPrevDayOfWeek(curDate, getPrevIndex(curDay));
    const firstDate = new Date(new Date(prevData.commissioned_at).toDateString());
    const secondDate = new Date(new Date(checkDay).toDateString());
    if (firstDate > secondDate) {
      result.push(prevData);
      curDate = new Date(prevData.commissioned_at);
      index += 1;
    } else if (firstDate.toDateString() === secondDate.toDateString()) {
      result.push(prevData);
      curDate = new Date(prevData.commissioned_at);
      index += 1;
    } else {
      result.push({ ...groupListStructure, commissioned_at: checkDay.toISOString() });
      checkDay.setHours(23, 59, 59, 999);
      curDate = checkDay;
    }
    curDay = curDate.getDay();
  }

  return result;
}

export const state = () => ({
  list: [],
  metaTotal: {},
  metaTotalTab: {},
  groupList: [],
  metaGroup: {},
});

export const getters = {
  getList: state => state.list || [],
  getTotal: state => state.metaTotal.total,
  getTotalCommission: state => state.metaTotal.total_commission,
  isLastData: state => state.list.length === 0 || state.list.length === state.metaTotalTab.total,
  getTotalTab: state => state.metaTotalTab.total,
  getGroupList: state => state.groupList || [],
  getGroupTotal: state => state.metaGroup.total,
};

export const mutations = {
  setList(state, data) {
    state.list = data;
  },
  updateStatusList(state, { code, status }) {
    state.list = state.list.map(data => (data.puzzle_code === code ? { ...data, status } : data));
  },
  setMetaTotal(state, data) {
    state.metaTotal = data;
  },
  setMetaTotalTab(state, data) {
    state.metaTotalTab = data;
  },
  setGroupList(state, data) {
    state.groupList = modifyGroupList(data);
  },
  setMetaGroup(state, data) {
    state.metaGroup = data;
  },
};

export const actions = {
  async getPuzzleMiliarderList({ commit, state }, params = {}) {
    try {
      const response = await getPuzzleMiliarderList(this.$axios, params);
      if (response.meta.http_status === 200) {
        commit('setList', params.offset ? [...state.list, ...response.data] : response.data);
        commit('setMetaTotalTab', response.meta);
        if (params.status === undefined) commit('setMetaTotal', response.meta);
      }
      return response;
    } catch (error) {
      // handle error
    }
  },
  async getPuzzleMiliarderGroupList({ commit, state }, params = {}) {
    try {
      const response = await getPuzzleMiliarderGroupList(this.$axios, params);
      if (response.meta.http_status === 200) {
        commit('setGroupList', params.offset ? [...state.groupList, ...response.data] : response.data);
        commit('setMetaGroup', response.meta);
      }
      return response;
    } catch (error) {
      // handle error
    }
  },
  async updateStatusPuzzleMiliarderList({ commit }, { code, status }) {
    try {
      const response = await updateStatusPuzzleMiliarderList(this.$axios, code, status);
      if (response.meta.http_status === 200) {
        commit('updateStatusList', { code, status });
      }
      return response;
    } catch (error) {
      // handle error
    }
  },
};
